import { STORAGE_TOKEN_KEY } from '../constants/storage-key';
import i18n from '../i18n';
import { IApiErrorResponse } from '../types/error-response.type';

export class ApiHelper {
  /**
   * Make API request url
   * @param path
   */
  static makeUrl(path: string): string {
    return `${process.env.REACT_APP_API_URL}/${path}`;
  }

  /**
   * Make API request options
   */
  static makeOptions(isJson = true): Partial<RequestInit> {
    const token = localStorage.getItem(STORAGE_TOKEN_KEY);

    const headers: { [key: string]: any } = {
      Accept: 'application/json',
      'X-localization': i18n.language,
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    if (isJson) {
      headers['Content-Type'] = 'application/json';
    }

    return {
      headers,
    };
  }

  /**
   * Handle API error
   *
   * @param data
   * @returns
   */
  static handleError(data: IApiErrorResponse) {
    let message: string[] = [];

    const keys = Object.keys(data.errors || {});

    if (keys.length > 1) {
      message = keys.reduce<string[]>((acc, key) => {
        acc.push(data.errors?.[key]?.join(' ') ?? '');

        return acc;
      }, []);
    } else {
      message.push(data.message);
    }

    if (!message.length) {
      return;
    }

    throw new Error(message.filter(Boolean).join(' '));
  }
}
